import { Play } from 'lucide-react';

const PitchVideoSection = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-background to-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Header */}
          <div className="mb-8 animate-fade-in">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
              <Play className="w-4 h-4" />
              Conheça a AI4ME
            </span>
            <h2 className="text-2xl md:text-4xl font-bold mb-4">
              <span className="bg-gradient-to-r from-primary to-orange-500 bg-clip-text text-transparent">
                Entenda nossa proposta em minutos
              </span>
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Descubra como a AI4ME pode transformar a gestão do seu negócio com inteligência artificial acessível e humanizada.
            </p>
          </div>

          {/* Video Player */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border/50 bg-card animate-fade-in">
            <video
              controls
              playsInline
              preload="metadata"
              className="w-full aspect-video"
              poster="/images/video-poster-ai4me.png"
            >
              <source src="/videos/pitch-ai4me.mp4" type="video/mp4" />
              Seu navegador não suporta vídeos HTML5.
            </video>
          </div>

          {/* Caption */}
          <p className="mt-4 text-sm text-muted-foreground">
            📢 Áudio gerado por IA via NotebookLM
          </p>
        </div>
      </div>
    </section>
  );
};

export default PitchVideoSection;
